import { AlertSubscriptionCoreBase } from "./alert-subscription.core.base"


export class AlertSubscriptionCore extends AlertSubscriptionCoreBase {

}